import { createContext, useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

export const TransportContext = createContext();

export const TransportProvider = ({ children }) => {
  const { pathname } = useLocation();
  const [transports, setTransports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const inFlightRef = useRef(null); // key van lopende fetch

  // hulpfuncties voor guards
  const isTransportPage = /^\/transport(\/|$)/.test(pathname || "");
  const transportMode = localStorage.getItem("transportMode") === "1";
  const transportUser = JSON.parse(localStorage.getItem("transportUser") || "null");
  const shippingAgent = transportUser?.company || null;

  useEffect(() => {
    // Voorwaarden om te mogen fetchen
    if (!isTransportPage || !transportMode || !shippingAgent) {
      return; // niks doen (en dus ook geen annul-log)
    }

    // Vorm een unieke key op basis van de huidige condities
    const fetchKey = `transports:${shippingAgent}:${pathname}`;
    // Voorkom parallelle calls voor dezelfde key
    if (inFlightRef.current === fetchKey) return;
    inFlightRef.current = fetchKey;

    const controller = new AbortController();

    const run = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/driver-transports`,
          {
            headers: { "X-Shipping-Agent": shippingAgent },
            signal: controller.signal,
          }
        );
        setTransports(Array.isArray(res.data) ? res.data : (res.data || []));
      } catch (err) {
        if (!axios.isCancel(err)) {
          console.error("❌ Transport ophalen mislukt:", err);
          setError("Kon transporten niet ophalen.");
        }
      } finally {
        if (inFlightRef.current === fetchKey) inFlightRef.current = null;
        setLoading(false);
      }
    };

    run();
    return () => controller.abort();
  }, [isTransportPage, transportMode, shippingAgent, pathname]);

  return (
    <TransportContext.Provider value={{ transports, loading, error, setTransports }}>
      {children}
    </TransportContext.Provider>
  );
};
